export enum DefaultImagePaths {
    album = 'client/assets/images/default/album.png',
    track = 'client/assets/images/default/album.png',
    artist = 'client/assets/images/default/artist_small.jpg',
    artistSmall = 'client/assets/images/default/artist_small.jpg',
    artistBig = 'client/assets/images/default/artist-big.jpg',
}
